// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { improvePageLinkStyles } from "@steiner/App/Components/ImprovePageLink/ImprovePageLink";
import InfoTooltip from "@steiner/XDL/Icons/InfoTooltip";
import { css } from "styled-components";

improvePageLinkStyles.Improvelink = {
    icon: {
        iconProps: {
            src: InfoTooltip,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
        position: "left",
    },
    typographyProps: {
        size: 12,
        lineHeight: "14px",
        weight: "bold",
    },
};
